import { createElement } from 'rax';
import classNames from 'classnames';
interface NavItemType {
  name: string;
  url: string;
  action?: string;
}
interface Props {
  lists: NavItemType[];
  className?: any;
}
export default ((props: Props) => {
  const {
    lists = [],
    className = ''
  } = props;
  const cls = classNames({
    'page-path': true,
    [className]: className
  });
  return <div className={cls}>
      {lists.map((item, index) => {
      if (index === lists.length - 1) {
        return <h1 className={'path'} key={index}>{item.name}</h1>;
      } else {
        return <a href={item.url || item.action} className={'path'} key={index}>
              {item.name}
            </a>;
      }
    })}
    </div>;
});